<template>
	<div>
		<!-- For some old tenants we are displaying old policy detail: -->
		<policy-detail-old :id="id" v-if="isOldPolicyDetail" />

		<!-- MOCK CMS: For Berkley -->
		<berkley-policy-detail :id="id" v-else-if="isBerkley" />

		<!-- MOCK CMS: For Asia -->
		<asia-policy-detail :id="id" v-else-if="isAsia" />

		<!-- For other tenants, we are displaying new policy detail  -->
		<policy-detail-new :id="id" v-else />
	</div>
</template>

<script>
import PolicyDetailNew from "../components/PolicyDetailNew.vue"
import PolicyDetailOld from "../components/PolicyDetailOld.vue"

// MOCK: CMS for Berkley
import BerkleyPolicyDetail from "../components/mockedBerkley/BerkleyPolicyDetail"

// MOCK: CMS for Asia
import AsiaPolicyDetail from "../components/mockedAsia/AsiaPolicyDetail"

export default {
	components: {
		PolicyDetailNew,
		PolicyDetailOld,

		// MOCK: CMS
		BerkleyPolicyDetail,

		// MOCK: CMS
		AsiaPolicyDetail
	},
	props: {
		// From router
		id: { type: String, required: true }
	},
	data() {
		return {
			isLoading: false
		}
	},
	computed: {
		isOldPolicyDetail() {
			const tenantIdsForOldPolicyDetail = [
				"apex",
				"apex_uat",
				// "asia",
				"vhis",
				"vhis_uat",
				"keepcovered_uat",
				"keepcovered"
			]
			return tenantIdsForOldPolicyDetail.includes(this.$store.state.tenantId)
		},

		isBerkley() {
			const tenantIds = ["berkley_uat", "berkley"]
			return tenantIds.includes(this.$store.state.tenantId)
		},

		isAsia() {
			// TODO: for prod after migration, allow also asia tenant and remove this comment
			return ["asia_uat", "asia"].includes(this.$store.state.tenantId)
		}
	}
}
</script>
